module.exports = __webpack_public_path__ + "img/AS0770003.d68b2660.jpg";